exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/*Devices*/\r\n/*Colors*/\r\n/*Syles*/\r\n/*Buttons*/\r\n/*Functions*/\r\n@media (min-width: 0px) {\r\n  #root .form-checkbox {\r\n    cursor: pointer; }\r\n  #root .form-checkbox-text {\r\n    display: inline-block;\r\n    margin-top: 0px; } }\r\n", ""]);

